<template>
  <div class="con-top">
    <div class="con-top-bgImg" v-if="isProductDetail">
      <div class="bgImg putBg" >
        <div class="text">
          <div class="text-box">
            <h1>{{name}}</h1>
            <p>{{model}}</p>
            <div></div>
            <span>{{description}}</span>
          </div>
          <div class="bgImg-right">
            <img :src="'/boot'+productUrl" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="con-top-bgImg" v-else>
      <div class="bgImg" :style="{ background: `url(${'/boot'+picture})`, 'background-size': 'cover' }" >
        <div class="text">
          <div v-html="createBy"></div>
        </div>
      </div>
    </div>
    <div class="con-top-top">
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    </div>
    <div class="con-top-box"></div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import {imgList, productsListNameId} from "@/utils/http";
export default {
  name: 'banner',
  props:['imgType','isProductDetail','productId'],
  components: {
    Breadcrumb
  },
  data() {
    return {
      picture:'',
      createBy:'',
      name:'',
      model:'',
      description:'',
      productUrl:'',
    };
  },
  created() {},
  watch:{
    productId(val){
      this.getProductsListNameId()
    }
  },
  mounted() {
    if(this.imgType){
      this.getBannerList()
    }else if(this.productId){
      this.getProductsListNameId()
    }
  },
  methods:{
    async getBannerList(){
      const res = await imgList(this.imgType);
      this.bannerList = res.rows
      this.picture = res.rows[0].picture
      this.createBy = res.rows[0].createBy
    },
    async getProductsListNameId(){
      const res = await productsListNameId(9999,'',this.productId);
      this.name = res.rows[0].name
      this.model = res.rows[0].model
      this.description = res.rows[0].description
      this.productUrl = res.rows[0].url
    },
  }
};
</script>

<style lang="scss" scoped>
.con-top{
  &-bgImg{
    width: 100%;
    .bgImg{
      width: 100%;
      height: 560px;
      .text{
        width: 1200px;
        height: 560px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bgImg-right{
          width: 686px;
          height: 381px;
          background-image:url("~@/assets/img/dizuo.png");
          background-size: cover;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            object-fit: cover;
          }
        }
        .text-box{
          width: 400px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          h1{
            font-weight: bold;
            font-size: 32px;
            color: #101010;
          }
          p{
            font-weight: 400;
            font-size: 30px;
            color: #101010;
            margin: 20px 0;
          }
          div{
            width: 396px;
            height: 1px;
            background: #839EB5;
            margin-bottom: 20px;
          }
          span{
            font-weight: 400;
            font-size: 15px;
            color: #4E4E4E;
            line-height: 31px;
            width: 100%;
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 8;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
        }
      }

    }
    .putBg{
      background-image:url("~@/assets/img/putDetBg.png");
      background-size: cover;
    }
  }
  &-top{
    width: 1200px;
    margin: 0 auto;
  }
  &-box{
    width: 100%;
    height: 20px;
    background: #F7F7F7;
  }
}
</style>